import { Tooltip } from "primereact/tooltip"
const CustomTooltip = ({ label, position, targetId }) => {
  return (
    <Tooltip
      className="custom-tooltip"
      position={position}
      target={`#${targetId}`}
    >
      <span>{label}</span>
    </Tooltip>
  )
}
export default CustomTooltip
